export enum SAP_MERCHANT_TYPE {
  'GENERAL_MERCHANT' = 'GM',
  'DISTRIBUTOR' = 'DI',
  'NATIONAL_RETAILER' = 'NR',
  'ONLINE_RETAILER' = 'OR',
  'KEY_ACCOUNT' = 'KA',
};
